module.exports = __webpack_public_path__ + "static/SingleFlowVectors-8b84ac11d068a99d032c9b65674c9429.png";